import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beforeNext", "tourKey", "stepKey", "useInStepKey", "navigationCallbackPath", "onClick"];
import { useContext, useRef } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import TourContext from '../contexts/TourContext';
import handleCallback from '../lib/handleCallback';
import { hasRedesignGate } from '../utils/redesignGate';
import UITourButton from './UITourButton';
import UITourNextButtonLegacy from './UITourNextButton.legacy';
import { jsx as _jsx } from "react/jsx-runtime";
const isTourStepMatched = (tourContext, stepKey) => {
  // If stepKey is empty, consider as matched
  if (!stepKey) {
    return true;
  }
  const currentStepKey = tourContext.getStep();
  return currentStepKey === stepKey;
};
const UITourNextButtonModern = props => {
  const {
    tour
  } = useContext(TourContext);
  const {
      beforeNext = emptyFunction,
      tourKey,
      stepKey,
      useInStepKey,
      navigationCallbackPath,
      onClick
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    getTour,
    getStep
  } = tour;
  const isHandlingClick = useRef(false);
  const handleClick = event => {
    // Skip click handler if:
    //   1. tour handler is executing
    //   2. Or current tour step are not matched with given props
    if (isHandlingClick.current || !isTourStepMatched(tour, useInStepKey)) {
      return null;
    }
    isHandlingClick.current = true;
    if (onClick) {
      onClick(event);
    }
    try {
      return handleCallback(beforeNext, () => {
        tour.next(stepKey);
        isHandlingClick.current = false;
        if (navigationCallbackPath && tour.navigationCallback) {
          tour.navigationCallback(navigationCallbackPath);
        }
      }, {
        tourKey: tourKey || getTour(),
        stepKey: stepKey || getStep()
      });
    } catch (error) {
      isHandlingClick.current = false;
      throw error;
    }
  };
  return /*#__PURE__*/_jsx(UITourButton, Object.assign({}, buttonProps, {
    onClick: handleClick
  }));
};
const UITourNextButton = props => {
  if (hasRedesignGate()) {
    return /*#__PURE__*/_jsx(UITourNextButtonModern, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(UITourNextButtonLegacy, Object.assign({}, props));
};
export { UITourNextButtonModern };
export default UITourNextButton;